import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'

import {formatCurrency} from 'utils'
import {cacheKeys} from 'api'

import useApi from '../api/useApi'

import useProfile from './useProfile'

const useBalanceTotal = () => {
  const api = useApi()
  const {profile} = useProfile()
  const {refetch, ...data} = useQuery([cacheKeys.balanceTotal], async () => {
    if (!profile) return null
    const value = await api.getBalance()
    return formatCurrency(value)
  })
  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile?.id])
  return {
    refetch,
    ...data,
  }
}
export default useBalanceTotal
